"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonDarkTheme = exports.buttonClassicTheme = exports.buttonThemeNamespace = void 0;

var _theme = require("@tablekit/theme");

var _utils = require("@tablekit/utils");

var _types = require("./types");

var _buttonClassicTheme, _buttonDarkTheme;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var buttonThemeNamespace = '@tablekit/button';
exports.buttonThemeNamespace = buttonThemeNamespace;
var buttonClassicTheme = (_buttonClassicTheme = {
  common: {
    focusOutlineColor: _theme.COLORS.BLUE.L4,
    backgroundDisabledColor: (0, _theme.color)('disabledBackground'),
    textDisabledColor: (0, _theme.color)('textSubtle')
  }
}, _defineProperty(_buttonClassicTheme, _types.APPEARANCES.PRIMARY, {
  backgroundGradientColorFrom: (0, _theme.color)('primary'),
  backgroundGradientColorTo: (0, _theme.color)('primary2'),
  textColor: 'white',
  backgroundHoverColor: (0, _theme.color)('primary'),
  backgroundActiveColor: (0, _theme.color)('primary2')
}), _defineProperty(_buttonClassicTheme, _types.APPEARANCES.OUTLINE, {
  textColor: (0, _theme.color)('primary2'),
  borderColor: (0, _theme.color)('primary'),
  textFocusColor: (0, _theme.color)('primary2'),
  borderFocusColor: (0, _theme.color)('primary'),
  backgroundHoverColor: (0, _theme.color)('primary'),
  textHoverColor: 'white',
  backgroundActiveColor: (0, _theme.color)('primary2'),
  textActiveColor: 'white',
  borderActiveColor: (0, _theme.color)('primary2'),
  shadowActiveColor: _theme.COLORS.GRAY_TRANSLUCENT.L2,
  borderDisabledColor: _theme.COLORS.GRAY_TRANSLUCENT.L3
}), _defineProperty(_buttonClassicTheme, _types.APPEARANCES.SUBTLE, {
  textColor: (0, _theme.color)('primary2'),
  textFocusColor: (0, _theme.color)('primary2'),
  backgroundHoverColor: function backgroundHoverColor(props) {
    return (0, _utils.hexToRgba)((0, _theme.color)('primary2')(props), 0.1);
  },
  textHoverColor: (0, _theme.color)('primary2'),
  backgroundActiveColor: function backgroundActiveColor(props) {
    return (0, _utils.hexToRgba)((0, _theme.color)('primary2')(props), 0.2);
  }
}), _defineProperty(_buttonClassicTheme, _types.APPEARANCES.GHOST, {
  borderColor: _theme.COLORS.GRAY_TRANSLUCENT.L3,
  textColor: _theme.COLORS.GRAY.L7,
  textFocusColor: _theme.COLORS.GRAY.L7,
  backgroundHoverColor: _theme.COLORS.GRAY.L3,
  textHoverColor: _theme.COLORS.GRAY.L7,
  backgroundActiveColor: _theme.COLORS.GRAY.L4
}), _defineProperty(_buttonClassicTheme, _types.APPEARANCES.INVERSE, {
  textColor: (0, _theme.color)('primary2'),
  backgroundColor: (0, _theme.color)('canvas'),
  backgroundHoverColor: (0, _theme.color)('primary2'),
  textHoverColor: 'white',
  shadowHoverColor: _theme.COLORS.GRAY_TRANSLUCENT.L4,
  backgroundDisabledColor: _theme.COLORS.GRAY_TRANSLUCENT.L2
}), _defineProperty(_buttonClassicTheme, _types.APPEARANCES.SUCCESS, {
  backgroundColor: (0, _theme.color)(_types.APPEARANCES.SUCCESS),
  backgroundHoverColor: _theme.COLORS.GREEN.L4,
  backgroundActiveColor: _theme.COLORS.GREEN.L6
}), _defineProperty(_buttonClassicTheme, _types.APPEARANCES.WARNING, {
  backgroundColor: _theme.COLORS.YELLOW.L6,
  backgroundHoverColor: _theme.COLORS.YELLOW.L5,
  backgroundActiveColor: _theme.COLORS.YELLOW.L7
}), _defineProperty(_buttonClassicTheme, _types.APPEARANCES.DANGER, {
  backgroundColor: (0, _theme.color)('danger'),
  backgroundHoverColor: _theme.COLORS.RED.L4,
  backgroundActiveColor: _theme.COLORS.RED.L6
}), _buttonClassicTheme);
exports.buttonClassicTheme = buttonClassicTheme;
var buttonDarkTheme = (_buttonDarkTheme = {}, _defineProperty(_buttonDarkTheme, _types.APPEARANCES.OUTLINE, {
  borderDisabledColor: (0, _theme.color)('disabledBackground')
}), _defineProperty(_buttonDarkTheme, _types.APPEARANCES.SUBTLE, {
  backgroundHoverColor: (0, _theme.color)('hoverPrimaryBackground'),
  backgroundActiveColor: _theme.COLORS.WHITE_TRANSLUCENT.L4
}), _defineProperty(_buttonDarkTheme, _types.APPEARANCES.GHOST, {
  borderColor: _theme.COLORS.WHITE_TRANSLUCENT.L4,
  textColor: _theme.COLORS.WHITE_TRANSLUCENT.L7,
  textFocusColor: _theme.COLORS.WHITE_TRANSLUCENT.L7,
  backgroundHoverColor: _theme.COLORS.WHITE_TRANSLUCENT.L4,
  textHoverColor: _theme.COLORS.WHITE_TRANSLUCENT.L7,
  backgroundActiveColor: _theme.COLORS.WHITE_TRANSLUCENT.L4
}), _buttonDarkTheme);
exports.buttonDarkTheme = buttonDarkTheme;